import axios from "axios";

const BASE_URL = process.env.REACT_APP_BEP_BASE_URL || "http://localhost:8000";

const login = (username, password) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            const token = "ABCD12345";
            resolve(token);
        }, 1000);
    });
};

const getPullSources = async() => {
    try {
        const response = await axios.get(`${BASE_URL}/app/data-sources`);
        return response.data;
    } catch (err) {
        throw err;
    }
};

const meta = (sourceName) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            const allMetaData = {
                news: {
                    pull: {
                    formFields: {
                        common: [
                            { name: "job_name", type: "String", required: true },
                            { name: "start_date", type: "Date", required: true },
                            { name: "end_date", type: "Date", required: true },
                            { name: "ticker", type: "Options", required: true },
                            // { name: "message_id", type: "String", required: false },
                        ],
                        enrich: [
                            { name: "enrichment_sources", type: "Options", required: true },
                        ],
                        transfer: [
                            { name: "transfer_sources", type: "Options", required: true },
                        ],
                    },
                    logFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "is_enriched", type: "Options", options: "enriched_by" },
                        {
                            name: "is_transferred",
                            type: "Options",
                            options: "transferred_to",
                        },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_pulled_timestamp", type: "Date" },
                    ],
                    tableFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "is_enriched", type: "Options", options: "enriched_by" },
                        {
                            name: "is_transferred",
                            type: "Options",
                            options: "transferred_to",
                        },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_pulled_timestamp", type: "Date" },
                    ],
                    outerTableFields: [
                        { name: "id", type: "String" },
                        { name: "title", type: "String" },
                        { name: "product_admin", type: "String" },
                        { name: "date_created", type: "Date" },
                    ],
                },
                enrich: {
                    formFields: {
                        common: [
                            { name: "job_name", type: "String", required: true },
                            { name: "start_date", type: "Date", required: true },
                            { name: "end_date", type: "Date", required: true },
                            { name: "ticker", type: "Options", required: true },
                            { name: "enrichment_sources", type: "Options", required: true },
                        ],
                    },
                    logFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "enrichment_source", type: "SingleOption" },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_enriched_timestamp", type: "Date" },
                    ],
                    tableFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "enrichment_source", type: "SingleOption" },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_enriched_timestamp", type: "Date" },
                    ],
                    outerTableFields: [
                        { name: "id", type: "String" },
                        { name: "title", type: "String" },
                        { name: "product_admin", type: "String" },
                        { name: "date_created", type: "Date" },
                    ],
                },
                transfer: {
                    formFields: {
                        common: [
                            { name: "job_name", type: "String", required: true },
                            { name: "start_date", type: "Date", required: true },
                            { name: "end_date", type: "Date", required: true },
                            { name: "ticker", type: "Options", required: true },
                            { name: "transfer_sources", type: "Options", required: true },
                        ],
                    },
                    logFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "transfer_source", type: "SingleOption" },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_transferred_timestamp", type: "Date" },
                    ],
                    tableFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "transfer_source", type: "SingleOption" },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_transferred_timestamp", type: "Date" },
                    ],
                    outerTableFields: [
                        { name: "id", type: "String" },
                        { name: "title", type: "String" },
                        { name: "product_admin", type: "String" },
                        { name: "date_created", type: "Date" },
                    ],
                },
                schedule: {
                    formFields: {
                        common: [
                            { name: "schedule_name", type: "String", required: true },
                            { name: "start_date", type: "Date", required: true },
                            { name: "ticker", type: "Options", required: true },
                            // { name: "Repeat", type: "Radio", choice: ["Custom", "Daily", "Weekly", "Monthly", ] },
                            {
                                name: "time_period",
                                type: "SubTypes",
                                types: [{
                                        name: "days",
                                        type: "String",
                                        required: true,
                                        number: true,
                                    },
                                    {
                                        name: "hours",
                                        type: "String",
                                        required: true,
                                        number: true,
                                    },
                                    {
                                        name: "minutes",
                                        type: "String",
                                        required: true,
                                        number: true,
                                    },
                                    {
                                        name: "seconds",
                                        type: "String",
                                        required: true,
                                        number: true,
                                    },
                                ],
                            },
                        ],
                        enrich: [
                            { name: "enrichment_sources", type: "Options", required: true },
                        ],
                        transfer: [
                            { name: "transfer_sources", type: "Options", required: true },
                        ],
                    },
                    tableFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "is_enriched", type: "Options", options: "enriched_by" },
                        {
                            name: "is_transferred",
                            type: "Options",
                            options: "transferred_to",
                        },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_pulled_timestamp", type: "Date" },
                    ],
                    outerTableFields: [
                        { name: "id", type: "String" },
                        { name: "schedule_name", type: "String" },
                        { name: "product_admin", type: "String" },
                        { name: "date_created", type: "Date" },
                        {
                            name: "time_period",
                            type: "TimePeriodObject",
                            sections: [
                                { name: "days", id: "days" },
                                { name: "hours", id: "hours" },
                                { name: "minutes", id: "min" },
                                { name: "seconds", id: "sec" },
                            ],
                        },
                    ],
                },
                },
                ibm_news: {
                    pull: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                // { name: "message_id", type: "String", required: false },
                            ],
                            enrich: [
                                { name: "enrichment_sources", type: "Options", required: true },
                            ],
                            transfer: [
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "is_enriched", type: "Options", options: "enriched_by" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "is_enriched", type: "Options", options: "enriched_by" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    enrich: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                { name: "enrichment_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "enrichment_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_enriched_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "enrichment_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_enriched_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    transfer: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "transfer_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_transferred_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "transfer_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_transferred_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    schedule: {
                        formFields: {
                            common: [
                                { name: "schedule_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                // { name: "Repeat", type: "Radio", choice: ["Custom", "Daily", "Weekly", "Monthly", ] },
                                {
                                    name: "time_period",
                                    type: "SubTypes",
                                    types: [{
                                            name: "days",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "hours",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "minutes",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "seconds",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                    ],
                                },
                            ],
                            enrich: [
                                { name: "enrichment_sources", type: "Options", required: true },
                            ],
                            transfer: [
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "is_enriched", type: "Options", options: "enriched_by" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "schedule_name", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                            {
                                name: "time_period",
                                type: "TimePeriodObject",
                                sections: [
                                    { name: "days", id: "days" },
                                    { name: "hours", id: "hours" },
                                    { name: "minutes", id: "min" },
                                    { name: "seconds", id: "sec" },
                                ],
                            },
                        ],
                    },
                },
                stocktwits: {
                    pull: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                            ],
                            enrich: [
                                { name: "enrichment_sources", type: "Options", required: true },
                            ],
                            transfer: [
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "is_enriched", type: "Options", options: "enriched_by" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "is_enriched", type: "Options", options: "enriched_by" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    enrich: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                { name: "enrichment_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "enrichment_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_enriched_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "enrichment_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_enriched_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    transfer: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "transfer_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_transferred_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "transfer_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_transferred_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    schedule: {
                        formFields: {
                            common: [
                                { name: "schedule_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                // { name: "Repeat", type: "Radio", choice: ["Custom", "Daily", "Weekly", "Monthly", ] },
                                {
                                    name: "time_period",
                                    type: "SubTypes",
                                    types: [{
                                            name: "days",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "hours",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "minutes",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "seconds",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                    ],
                                },
                            ],
                            enrich: [
                                { name: "enrichment_sources", type: "Options", required: true },
                            ],
                            transfer: [
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "is_enriched", type: "Options", options: "enriched_by" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "schedule_name", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                            {
                                name: "time_period",
                                type: "TimePeriodObject",
                                sections: [
                                    { name: "days", id: "days" },
                                    { name: "hours", id: "hours" },
                                    { name: "minutes", id: "min" },
                                    { name: "seconds", id: "sec" },
                                ],
                            },
                        ],
                    },
                },
                alphavantage: {
                    pull: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                            ],
                            transfer: [
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    transfer: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "transfer_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_transferred_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "transfer_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_transferred_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    schedule: {
                        formFields: {
                            common: [
                                { name: "schedule_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                // { name: "Repeat", type: "Radio", choice: ["Custom", "Daily", "Weekly", "Monthly", ] },
                                {
                                    name: "time_period",
                                    type: "SubTypes",
                                    types: [{
                                            name: "days",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "hours",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "minutes",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "seconds",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                    ],
                                },
                            ],
                            transfer: [
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "schedule_name", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                            {
                                name: "time_period",
                                type: "TimePeriodObject",
                                sections: [
                                    { name: "days", id: "days" },
                                    { name: "hours", id: "hours" },
                                    { name: "minutes", id: "min" },
                                    { name: "seconds", id: "sec" },
                                ],
                            },
                        ],
                    },
                },
                reddit: {
                    pull: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                            ],
                            enrich: [
                                { name: "enrichment_sources", type: "Options", required: true },
                            ],
                            transfer: [
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "is_enriched", type: "Options", options: "enriched_by" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "is_enriched", type: "Options", options: "enriched_by" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    enrich: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                { name: "enrichment_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "enrichment_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_enriched_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "enrichment_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_enriched_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    transfer: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "transfer_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_transferred_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "transfer_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_transferred_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    schedule: {
                        formFields: {
                            common: [
                                { name: "schedule_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                {
                                    name: "time_period",
                                    type: "SubTypes",
                                    types: [{
                                            name: "days",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "hours",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "minutes",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "seconds",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                    ],
                                },
                            ],
                            enrich: [
                                { name: "enrichment_sources", type: "Options", required: true },
                            ],
                            transfer: [
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "is_enriched", type: "Options", options: "enriched_by" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "schedule_name", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                            {
                                name: "time_period",
                                type: "TimePeriodObject",
                                sections: [
                                    { name: "days", id: "days" },
                                    { name: "hours", id: "hours" },
                                    { name: "minutes", id: "min" },
                                    { name: "seconds", id: "sec" },
                                ],
                            },
                        ],
                    },
                },
                gtrends: {
                    pull: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                            ],
                            transfer: [
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    transfer: {
                        formFields: {
                            common: [
                                { name: "job_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "end_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        logFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "transfer_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_transferred_timestamp", type: "Date" },
                        ],
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            { name: "transfer_source", type: "SingleOption" },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_transferred_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "title", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                        ],
                    },
                    schedule: {
                        formFields: {
                            common: [
                                { name: "schedule_name", type: "String", required: true },
                                { name: "start_date", type: "Date", required: true },
                                { name: "ticker", type: "Options", required: true },
                                // { name: "Repeat", type: "Radio", choice: ["Custom", "Daily", "Weekly", "Monthly", ] },
                                {
                                    name: "time_period",
                                    type: "SubTypes",
                                    types: [{
                                            name: "days",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "hours",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "minutes",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                        {
                                            name: "seconds",
                                            type: "String",
                                            required: true,
                                            number: true,
                                        },
                                    ],
                                },
                            ],
                            transfer: [
                                { name: "transfer_sources", type: "Options", required: true },
                            ],
                        },
                        tableFields: [
                            { name: "id", type: "String" },
                            { name: "ticker", type: "String" },
                            { name: "start_date", type: "Date" },
                            { name: "end_date", type: "Date" },
                            {
                                name: "is_transferred",
                                type: "Options",
                                options: "transferred_to",
                            },
                            { name: "progress", type: "Progress" },
                            { name: "status", type: "String" },
                            { name: "last_pulled_timestamp", type: "Date" },
                        ],
                        outerTableFields: [
                            { name: "id", type: "String" },
                            { name: "schedule_name", type: "String" },
                            { name: "product_admin", type: "String" },
                            { name: "date_created", type: "Date" },
                            {
                                name: "time_period",
                                type: "TimePeriodObject",
                                sections: [
                                    { name: "days", id: "days" },
                                    { name: "hours", id: "hours" },
                                    { name: "minutes", id: "min" },
                                    { name: "seconds", id: "sec" },
                                ],
                            },
                        ],
                    },
                },
                bluesky: {
                    pull: {
                    formFields: {
                        common: [
                            { name: "job_name", type: "String", required: true },
                            { name: "start_date", type: "Date", required: true },
                            { name: "end_date", type: "Date", required: true },
                            { name: "ticker", type: "Options", required: true },
                            // { name: "message_id", type: "String", required: false },
                        ],
                        enrich: [
                            { name: "enrichment_sources", type: "Options", required: true },
                        ],
                        transfer: [
                            { name: "transfer_sources", type: "Options", required: true },
                        ],
                    },
                    logFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "is_enriched", type: "Options", options: "enriched_by" },
                        {
                            name: "is_transferred",
                            type: "Options",
                            options: "transferred_to",
                        },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_pulled_timestamp", type: "Date" },
                    ],
                    tableFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "is_enriched", type: "Options", options: "enriched_by" },
                        {
                            name: "is_transferred",
                            type: "Options",
                            options: "transferred_to",
                        },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_pulled_timestamp", type: "Date" },
                    ],
                    outerTableFields: [
                        { name: "id", type: "String" },
                        { name: "title", type: "String" },
                        { name: "product_admin", type: "String" },
                        { name: "date_created", type: "Date" },
                    ],
                },
                enrich: {
                    formFields: {
                        common: [
                            { name: "job_name", type: "String", required: true },
                            { name: "start_date", type: "Date", required: true },
                            { name: "end_date", type: "Date", required: true },
                            { name: "ticker", type: "Options", required: true },
                            { name: "enrichment_sources", type: "Options", required: true },
                        ],
                    },
                    logFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "enrichment_source", type: "SingleOption" },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_enriched_timestamp", type: "Date" },
                    ],
                    tableFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "enrichment_source", type: "SingleOption" },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_enriched_timestamp", type: "Date" },
                    ],
                    outerTableFields: [
                        { name: "id", type: "String" },
                        { name: "title", type: "String" },
                        { name: "product_admin", type: "String" },
                        { name: "date_created", type: "Date" },
                    ],
                },
                transfer: {
                    formFields: {
                        common: [
                            { name: "job_name", type: "String", required: true },
                            { name: "start_date", type: "Date", required: true },
                            { name: "end_date", type: "Date", required: true },
                            { name: "ticker", type: "Options", required: true },
                            { name: "transfer_sources", type: "Options", required: true },
                        ],
                    },
                    logFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "transfer_source", type: "SingleOption" },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_transferred_timestamp", type: "Date" },
                    ],
                    tableFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "transfer_source", type: "SingleOption" },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_transferred_timestamp", type: "Date" },
                    ],
                    outerTableFields: [
                        { name: "id", type: "String" },
                        { name: "title", type: "String" },
                        { name: "product_admin", type: "String" },
                        { name: "date_created", type: "Date" },
                    ],
                },
                schedule: {
                    formFields: {
                        common: [
                            { name: "schedule_name", type: "String", required: true },
                            { name: "start_date", type: "Date", required: true },
                            { name: "ticker", type: "Options", required: true },
                            // { name: "Repeat", type: "Radio", choice: ["Custom", "Daily", "Weekly", "Monthly", ] },
                            {
                                name: "time_period",
                                type: "SubTypes",
                                types: [{
                                        name: "days",
                                        type: "String",
                                        required: true,
                                        number: true,
                                    },
                                    {
                                        name: "hours",
                                        type: "String",
                                        required: true,
                                        number: true,
                                    },
                                    {
                                        name: "minutes",
                                        type: "String",
                                        required: true,
                                        number: true,
                                    },
                                    {
                                        name: "seconds",
                                        type: "String",
                                        required: true,
                                        number: true,
                                    },
                                ],
                            },
                        ],
                        enrich: [
                            { name: "enrichment_sources", type: "Options", required: true },
                        ],
                        transfer: [
                            { name: "transfer_sources", type: "Options", required: true },
                        ],
                    },
                    tableFields: [
                        { name: "id", type: "String" },
                        { name: "ticker", type: "String" },
                        { name: "start_date", type: "Date" },
                        { name: "end_date", type: "Date" },
                        { name: "is_enriched", type: "Options", options: "enriched_by" },
                        {
                            name: "is_transferred",
                            type: "Options",
                            options: "transferred_to",
                        },
                        { name: "progress", type: "Progress" },
                        { name: "status", type: "String" },
                        { name: "last_pulled_timestamp", type: "Date" },
                    ],
                    outerTableFields: [
                        { name: "id", type: "String" },
                        { name: "schedule_name", type: "String" },
                        { name: "product_admin", type: "String" },
                        { name: "date_created", type: "Date" },
                        {
                            name: "time_period",
                            type: "TimePeriodObject",
                            sections: [
                                { name: "days", id: "days" },
                                { name: "hours", id: "hours" },
                                { name: "minutes", id: "min" },
                                { name: "seconds", id: "sec" },
                            ],
                        },
                    ],
                },
                },
                
            };

            resolve(allMetaData[sourceName]);
        }, 1000);
    });
};

const get_all_jobs = async(token, sourceKey) => {
    try {
        const response = await axios.get(`${BASE_URL}/${sourceKey}/get-jobs/`);
        return response.data;
    } catch (err) {
        throw err;
    }
};

const get_running_jobs = async(token, sourceKey) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/${sourceKey}/get-running-jobs/`
        );
        return response.data;
    } catch (err) {
        throw err;
    }
};

const available_tickers = async(token) => {
    try {
        const response = await axios.get(`${BASE_URL}/app/available-tickers`);
        return response.data;
    } catch (err) {
        throw err;
    }
};

const get_enrichment_sources = async(token) => {
    try {
        const response = await axios.get(`${BASE_URL}/app/enrichment-sources`);
        return response.data;
    } catch (err) {
        throw err;
    }
};

const get_transfer_sources = async(token) => {
    try {
        const response = await axios.get(`${BASE_URL}/app/transfer-sources`);
        return response.data;
    } catch (err) {
        throw err;
    }
};

const get_schedules = async(token, sourceKey) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/${sourceKey}/get-enabled-schedules/`
        );
        return response.data;
    } catch (err) {
        throw err;
    }
};
const create_schedule = (token, sourceKey, jobObj, objTypes, setRefresh) => {
    try {
        Object.keys(objTypes).forEach((value) => {
            jobObj = {...jobObj, ...jobObj[value] };
            jobObj[value] = objTypes[value];
        });

        axios
            .post(`${BASE_URL}/${sourceKey}/create-schedule/`, jobObj)
            .then((response) => {
                console.log(response.data);
                setRefresh((prevValue) => !prevValue);
            })
            .catch((err) => {
                console.log(err);
                alert("Error");
            });
    } catch (err) {
        throw err;
    }
};

const disable_schedule = async(token, sourceKey, scheduleID, _) => {
    try {
        let response = await axios.get(
            `${BASE_URL}/${sourceKey}/disable-schedule/${scheduleID}`
        );

        console.log(response.data);
    } catch (err) {
        throw err;
    }
};

const create_pull_job = (token, sourceKey, jobObj, objTypes, setRefresh) => {
    try {
        Object.keys(objTypes).forEach((value) => {
            jobObj = {...jobObj, ...jobObj[value] };
            jobObj[value] = objTypes[value];
        });

        axios
            .post(`${BASE_URL}/${sourceKey}/create-pull-job/`, jobObj)
            .then((response) => {
                console.log(response.data);
                setRefresh((prevValue) => !prevValue);
            })
            .catch((err) => {
                console.log(err);
                alert("Error");
            });
    } catch (err) {
        throw err;
    }
};

const create_enrichment_job = (
    token,
    sourceKey,
    jobObj,
    objTypes,
    setRefresh
) => {
    try {
        Object.keys(objTypes).forEach((value) => {
            jobObj = {...jobObj, ...jobObj[value] };
            jobObj[value] = objTypes[value];
        });

        axios
            .post(`${BASE_URL}/${sourceKey}/create-enrichment-job/`, jobObj)
            .then((response) => {
                console.log(response.data);
                setRefresh((prevValue) => !prevValue);
            })
            .catch((err) => {
                console.log(err);
                alert("Error");
            });
    } catch (err) {
        throw err;
    }
};

const create_transfer_job = (
    token,
    sourceKey,
    jobObj,
    objTypes,
    setRefresh
) => {
    try {
        Object.keys(objTypes).forEach((value) => {
            jobObj = {...jobObj, ...jobObj[value] };
            jobObj[value] = objTypes[value];
        });

        axios
            .post(`${BASE_URL}/${sourceKey}/create-transfer-job/`, jobObj)
            .then((response) => {
                console.log(response.data);
                setRefresh((prevValue) => !prevValue);
            })
            .catch((err) => {
                console.log(err);
                alert("Error");
            });
    } catch (err) {
        throw err;
    }
};

const stop_job = async(token, sourceKey, jobID, type, inner) => {
    try {
        let response;

        if (!inner)
            response = await axios.get(`${BASE_URL}/${sourceKey}/stop-job/${jobID}`);
        else {
            response = await axios.get(
                `${BASE_URL}/${sourceKey}/stop-${type}-job/${jobID}`
            );
        }
        console.log(response.data);
    } catch (err) {
        throw err;
    }
};

const api = {
    getPullSources,
    get_schedules,
    login,
    available_tickers,
    get_enrichment_sources,
    get_transfer_sources,
    get_running_jobs,
    get_all_jobs,
    stop_job,
    disable_schedule,
    create_pull_job,
    create_enrichment_job,
    create_transfer_job,
    create_schedule,
    meta,
};
export default api;